// extracted by mini-css-extract-plugin
module.exports = {"steps":"onboarding_steps__3F-3P","button":"onboarding_button__3ok9u"};